/**
 * @utility-ng-progression
 */
import { Progression, Reflow } from 'utility-js-progression';

angular.module('utility-ng-progression', []).constant('ngProgression', Progression).constant('ngReflow', Reflow);



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-progression/src/main.ts